<template>
    <v-layout row wrap>
        <v-flex tag="h2" v-if="!isBannerVisible">
            <router-view name="banner" class="banner-view" >
            </router-view>
        </v-flex>
        <v-flex xs12 class="white_background">
            <router-view />
        </v-flex>
    </v-layout>
</template>

<script>

    export default {
        name: "ResourceDirectoryMain",
        data: () => ({

        }),
        computed: {
            isBannerVisible() {
                return this.$route.path.includes("/speakerProfile");
            },
        },
    };
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">

</style>
